import requests from "./httpService";

const AirportServices = {

  addAirport: async (body) => {
    return requests.post("/flightcities/add", body);
  },
  getAirportList : async ()=>{
   return requests.get("/flightcities/");
  },
  
  getAllAirport: async (body) => {
    return requests.get("/place/flightcities/all/", body);
  },
  getPeriodicAirport: async (body) => {
    return requests.get("/place/getCities/airport", body);
  },
  getAirportById: async (id, body) => {
    return requests.get(`/flightCities/${id}`, body);
  },

  updateAirport: async (id, body) => {
    return requests.put(`/flightCities/update/${id}`, body);
  },

  deleteAirport: async (id) => {
    return requests.delete(`/flightCities/delete/${id}`);
  },
 
};

export default AirportServices;
